"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendUpdateTrackerFactory = void 0;
const frontend_update_tracker_1 = require("./frontend-update-tracker");
class FrontendUpdateTrackerFactory {
    static initialize(options) {
        if (window.frontendUpdateTracker) {
            return;
        }
        window.frontendUpdateTracker = new frontend_update_tracker_1.FrontendUpdateTracker(options);
    }
}
exports.FrontendUpdateTrackerFactory = FrontendUpdateTrackerFactory;
